'use client';
import React from 'react';

const logos = [
  { label: 'Bitcoin', img: '/assets/payment/btc.png' },
  { label: 'Bitcoin Cash', img: '/assets/payment/bch.png' },
  { label: 'Ethereum', img: '/assets/payment/eth.png' },
  { label: 'USDT', img: '/assets/payment/usdt.png' },
  { label: 'USDC', img: '/assets/payment/usdc.png' },
  { label: 'TRON', img: '/assets/payment/trx.png' },
  { label: 'BNB Chain', img: '/assets/payment/bnb.png' },
  { label: 'M-Pesa', img: '/assets/payment/mpesa.svg' },
  { label: 'Visa', img: '/assets/payment/visa.svg' },
  { label: 'Mastercard', img: '/assets/payment/mastercard.svg' },
  { label: 'Skrill', img: '/assets/payment/skrill.svg' },
  { label: 'TRC-20', img: '/assets/payment/trx.png' },
  { label: 'ERC-20', img: '/assets/payment/eth.png' },
];

// Duplicate for seamless loop
const doubled = [...logos, ...logos, ...logos];

export default function PaymentMarquee() {
  return (
    <section
      className="py-10 overflow-hidden"
      style={{ borderTop: '1px solid #000000', background: '#000000' }}
    >
      <div className="mb-5 text-center">
        <p className="text-xs font-semibold tracking-widest uppercase text-muted-foreground">
          Accepted Payment Methods
        </p>
      </div>

      {/* Marquee track */}
      <div className="relative">
        {/* Fade edges */}
        <div
          className="absolute left-0 top-0 h-full w-24 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(90deg, #000000, transparent)' }}
        />
        <div
          className="absolute right-0 top-0 h-full w-24 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(270deg, #000000, transparent)' }}
        />

        <div className="marquee-track flex gap-6 w-max">
          {doubled.map((m, i) => (
            <div
              key={`${m.label}-${i}`}
              className="flex flex-col items-center gap-2 flex-shrink-0"
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center"
                style={{ background: '#000000', border: '1px solid #222' }}
              >
                <img
                  src={m.img}
                  alt={m.label}
                  className="w-10 h-10 object-contain"
                  loading="lazy"
                />
              </div>
              <span className="text-[10px] text-muted-foreground font-medium whitespace-nowrap">
                {m.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-5 text-center">
        <a
          href="/payments"
          className="text-xs text-muted-foreground hover:text-primary transition-colors underline underline-offset-4"
        >
          View processing times & fees →
        </a>
      </div>

      <style jsx>{`
        .marquee-track {
          animation: marquee 42s linear infinite;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
        @keyframes marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
      `}</style>
    </section>
  );
}
